import ErrorHandler from "/global/js/errorHandler.js";
import {Util} from '/global/js/util.js';

new ErrorHandler();
const util = new Util();
util.bootstrapWasValidated();
util.addAsteriskRequiredFieldsLabel();